import { gridClasses } from '@mui/x-data-grid';

const style = {
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: '#e6e6e6',
  },
  [`& .${gridClasses.row}.odd`]: {
    backgroundColor: '#f2f2f2',
  },
  [`& .${gridClasses.row}`] : {
    '&:hover, &.Mui-hovered': {
      backgroundColor: '#B5D4D4',
      color: '#003333',
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    }
  },
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnHeader}`]:
  {
    color: '#fff',
    backgroundColor: '#008080'
  },
  ['& .MuiDataGrid-iconSeparator']:
  {
    display: 'none',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
  {
    outline: 'none',
  },
  [`& .${gridClasses.iconButtonContainer} .MuiButtonBase-root,
    & .${gridClasses.menuIcon} .MuiButtonBase-root`]: {
    color: '#fff'
  },
  ['& MuiDataGrid-columnsContainer, .MuiDataGrid-cell']: {
    border: 'none'
  },
  ['& MuiDataGrid-virtualScroller']: {
    minHeight: '39px'
  }
}; 
export default style;